import { forwardRef } from 'react';

import { CardTitle, CardContainer, CardIcon, CardText } from './styles';
import { getIcon } from './how-your-plan-works.utils';

export type PlanCardType = {
  text: string;
  color: string;
  title: string;
  icon: string;
};

const PlanCard = forwardRef<HTMLDivElement, PlanCardType>((props, ref) => {
  const { text, color, title, icon } = props;
  return (
    <CardContainer backgroundColor={color} ref={ref}>
      <CardIcon>{getIcon(icon)}</CardIcon>
      <CardTitle className="title-small">{title}</CardTitle>
      <CardText
        className="body-large"
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </CardContainer>
  );
});
//Necessary attribute because of the use of the forwardRef
PlanCard.displayName = 'PlanCard';
export default PlanCard;
